// ----------------------------------------------------------------------
import type { Theme } from "@mui/material";

const Autocomplete = (theme: Theme) => ({
  MuiAutocomplete: {
    styleOverrides: {
      paper: {
        boxShadow: theme.customShadows.z20,
      },
    },
  },
});

export default Autocomplete;
